// East Africa Time has no daylight saving and is a fixed UTC+3 offset.
const EAT_UTC_OFFSET_HOURS = 3;

// Default length of the upload window, opening at the exam's scheduled
// start time - independent of the exam's own duration, which is often too
// short a window for examiners to upload all candidates' work.
const DEFAULT_UPLOAD_WINDOW_HOURS = 24;

// Returns { start: Date, end: Date } representing the exam's upload window
// (examStartTime through examStartTime + DEFAULT_UPLOAD_WINDOW_HOURS, on
// examDate, interpreted in EAT), or null if the job doesn't have complete
// timing data. The window may span past midnight into the next day.
export function getExamUploadWindow(job) {
  if (!job?.examDate || !job?.examStartTime) {
    return null;
  }

  const [year, month, day] = job.examDate.split('-').map(Number);
  const [startHour, startMinute] = job.examStartTime.split(':').map(Number);

  const start = new Date(Date.UTC(year, month - 1, day, startHour - EAT_UTC_OFFSET_HOURS, startMinute));
  const end = new Date(start.getTime() + DEFAULT_UPLOAD_WINDOW_HOURS * 60 * 60000);

  return { start, end };
}

// phase is one of: 'before' (window not open yet), 'during' (upload allowed),
// 'after' (window closed), 'unknown' (missing timing data).
export function getUploadPhase(job, now = new Date()) {
  const window = getExamUploadWindow(job);
  if (!window) return { phase: 'unknown', window: null };
  if (now < window.start) return { phase: 'before', window };
  if (now > window.end) return { phase: 'after', window };
  return { phase: 'during', window };
}

export function isUploadAllowed(job, now = new Date()) {
  return getUploadPhase(job, now).phase === 'during';
}

export function formatCountdown(msRemaining) {
  const clamped = Math.max(0, msRemaining);
  const totalSeconds = Math.floor(clamped / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (n) => String(n).padStart(2, '0');
  return `${days} Days : ${pad(hours)} Hours : ${pad(minutes)} Minutes : ${pad(seconds)} Seconds`;
}
